import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProductTagsComponent } from '@shared/product-tags/product-tags.component';
import { TagProductDsComponent } from '@design-system/components/organisms/tag-product/tag-product.component';

@NgModule({
  declarations: [ProductTagsComponent],
  imports: [
    CommonModule,
    TagProductDsComponent,
  ],
  exports: [ProductTagsComponent]
})
export class ProductTagsModule { }
